<div class="home-image-box animated fadeIn fast">
  <img class="home-image" src="assets/images/banner.png" alt="Bienvenido a la Extranet" />
</div>
<router-outlet></router-outlet>

